'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectAssign = require('object-assign');

var _objectAssign2 = _interopRequireDefault(_objectAssign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * Copyright (c) 2015-present, Zippy Technologies
                                                                                                                                                                                                                   *
                                                                                                                                                                                                                   * This source code is licensed under the MIT license found in the
                                                                                                                                                                                                                   * LICENSE file in the root directory of this source tree.
                                                                                                                                                                                                                   */

/**
 * Returns a map with all it children
 * checked or uncheded, depending on
 * check value
 * @param {Object} nodeProps - nodeProps
 * @param {Bool} checked
 * @return {Object} checkMap
 */
function changeChildrenCheckProperty(nodeProps, newState) {
  // if the node is disabled, it and it's children should
  // not change
  if (!nodeProps || nodeProps.disabled) {
    return null;
  }

  var propertyMap = _defineProperty({}, nodeProps.path, newState);

  if (nodeProps.children) {
    var children = nodeProps.children.map(function (child) {
      return changeChildrenCheckProperty(child.props, newState);
    });

    children.forEach(function (child) {
      (0, _objectAssign2.default)(propertyMap, child);
    });
  }

  return propertyMap;
}

exports.default = changeChildrenCheckProperty;